<template>
  <div>
    <the-headersider />

    <base-card class="card">
      <h2 class="title">Link Payment to Client</h2>
      <p class="subtitle">
Transaction ID        <strong>{{ paymentReference }}</strong>
      </p>
      

      <!-- Search input -->
      <input
        type="text"
        v-model="search"
        placeholder="Search client by name or phone"
        class="search"
        @focus="showDropdown = true"
      />

      <!-- Dropdown -->
      <div v-if="showDropdown" class="dropdown">
        <div
          v-for="client in filteredClients"
          :key="client.id"
          class="dropdown-item"
          @click="selectClient(client)"
        >
          <strong>{{ client.client_name }}</strong>
          <small>{{ client.phone }}</small>
        </div>

        <div v-if="filteredClients.length === 0" class="empty">
          No clients found
        </div>
      </div>

      <!-- Selected client -->
      <div v-if="selectedClient" class="selected">
        <p>
          Selected Client:
          <strong>{{ selectedClient.client_name }}</strong>
          ({{ selectedClient.phone }})
        </p>
      </div>

      <!-- Actions -->
      <button
        class="btn"
        :disabled="!selectedClient || loading"
        @click="submit"
      >
        {{ loading ? "Updating..." : "Update Payment" }}
      </button>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clients: [],
      search: "",
      selectedClient: null,
      showDropdown: false,
      loading: false,
    };
  },

  computed: {
    paymentReference() {
      return this.$route.params.payment_reference;
    },

    filteredClients() {
      const key = this.search.toLowerCase();
      return this.clients.filter(
        c =>
          c.client_name.toLowerCase().includes(key) ||
          (c.phone && c.phone.includes(key))   ||
          (c.alternative_phone && c.alternative_phone.includes(key)) 
      );
    },
  },

  mounted() {
    this.fetchClients();
  },

  methods: {
    async fetchClients() {
      try {
        const res = await fetch(
          "https://api.roberms.com/get/clients"
        );
        this.clients = await res.json();
      } catch (err) {
        console.error("Failed to load clients", err);
      }
    },

    selectClient(client) {
      this.selectedClient = client;
      this.search = `${client.client_name} (${client.phone})`;
      this.showDropdown = false;
    },

    async submit() {
      if (!this.selectedClient) return;

      this.loading = true;

      try {
        const res = await fetch(
          `https://api.roberms.com/mpesa/${this.paymentReference}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              clientId: this.selectedClient.id,
            }),
          }
        );

        if (!res.ok) throw new Error("Update failed");

        alert("Payment updated successfully");
        this.$router.push("/mpesa/payments");
      } catch (err) {
        console.error(err);
        alert("Failed to update payment as the transaction cide has been processed");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.card {
  max-width: 500px;
  margin: auto;
}

.title {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
}

.subtitle {
  font-size: 0.85rem;
  color: #6b7280;
  margin-bottom: 1rem;
}

.search {
  width: 100%;
  padding: 0.6rem;
  border-radius: 8px;
  border: 1px solid #d1d5db;
}

.dropdown {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-top: 0.3rem;
  max-height: 220px;
  overflow-y: auto;
  background: white;
}

.dropdown-item {
  padding: 0.6rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}

.dropdown-item:hover {
  background: #f9fafb;
}

.dropdown-item small {
  color: #6b7280;
}

.empty {
  padding: 0.6rem;
  text-align: center;
  color: #9ca3af;
}

.selected {
  margin-top: 0.8rem;
  font-size: 0.9rem;
}

.btn {
  margin-top: 1rem;
  width: 100%;
  padding: 0.7rem;
  border-radius: 8px;
  background: #2563eb;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
